export const engagementAppGroupIdSurveysSurveyStatsSummary =
  "/engagement/:app_group_id/surveys/survey_stats_summary";
